<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="display"
        :label="label"
        :rules="rules"
        :dense="dense"
        :outlined="outlined"
        prepend-icon="mdi-calendar"
        readonly
        clearable
        v-bind="attrs"
        @click:clear="clear"
        v-on="on"
      />
    </template>
    <v-card>
      <v-date-picker
        v-model="date"
        locale="ru-ru"
        :first-day-of-week="1"
        no-title
      />
      <v-time-picker
        v-if="withTime && date"
        v-model="time"
        format="24hr"
      />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          :disabled="!date"
          @click="apply"
        >
          Выбрать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
// Поле даты/даты-времени СКУД: русский календарь, неделя с понедельника, время 24ч местное.
// v-model наружу — строка как у нативного инпута: 'YYYY-MM-DD' или 'YYYY-MM-DDTHH:mm',
// поэтому конвертации moment(value).toISOString() в формах не меняются.
import moment from 'moment'

export default {
  name: 'SkudDateField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    withTime: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      menu: false,
      date: null,
      time: '00:00'
    }
  },
  computed: {
    display () {
      if (!this.date) return ''
      const fmt = this.withTime ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'
      return moment(`${this.date}T${this.time}`).format(fmt)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        this.syncFromValue(v)
      }
    },
    menu (open) {
      if (open) this.syncFromValue(this.value)
      else this.emit()
    }
  },
  methods: {
    syncFromValue (v) {
      if (!v) {
        this.date = null
        this.time = '00:00'
        return
      }
      const [d, t] = v.split('T')
      this.date = d || null
      this.time = t ? t.slice(0, 5) : '00:00'
    },
    apply () {
      this.emit()
      this.menu = false
    },
    emit () {
      if (!this.date) return
      const v = this.withTime ? `${this.date}T${this.time}` : this.date
      this.$emit('input', v)
    },
    clear () {
      this.date = null
      this.time = '00:00'
      this.$emit('input', '')
    }
  }
}
</script>
